import { ConfigField, ConfigSlideId } from '@/eventConfig/types';
import { useEventConfig } from '@/eventConfig/useEventConfig';
import { FormGetFieldValueFn } from '@/form/FormProvider';
import { translate } from '@/translation/translate';
import { BmiValidation, useBmiValidation } from '@/util/useBmiValidation';
import { FC } from 'react';

interface BmiDisplayProps {
  field: ConfigField;
  slideId: ConfigSlideId;
  getFieldValue: FormGetFieldValueFn;
}

export const BmiDisplay: FC<BmiDisplayProps> = ({ field, getFieldValue }) => {
  const bmiValidationResult: BmiValidation = useBmiValidation(getFieldValue);
  const { eventConfig } = useEventConfig();

  const htmlId = 'id_field_' + field.name;

  const getBmiValue = () => {
    return `${bmiValidationResult.bmi?.bmi.toFixed(1)}`;
  };

  return (
    <div className="col-12 field bmi-display">
      <label>{translate(eventConfig?.translations.yourBmi)}</label>
      <span id={htmlId}>{bmiValidationResult.bmi?.bmi ? getBmiValue() : '-'}</span>
    </div>
  );
};
